module.exports = __webpack_public_path__ + "img/bulb.5d3cd71a.svg";